import Vue from 'vue'
import Router from 'vue-router'

import Base from '@/components/Base'
import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'
import Reset from '@/components/Auth/Reset'
import PasswordEdit from '@/components/Profile/PasswordEdit'

import ProfileBase from '@/components/Profile/ProfileBase'
import ProfileEdit from '@/components/Profile/ProfileEdit'

import PublicProfile from '@/components/Profile/PublicProfile.vue'
import Leaderboard from '@/components/Profile/Leaderboard.vue'

import GPSTracks from '@/components/GPS/Tracks'
import Hike from '@/components/Hikes/Hike'
import Hikes from '@/components/Hikes/Hikes'
import HikeAdd from '@/components/Hikes/HikeAdd'
import Badges from '@/components/Hikes/Badges'

import Chat from '@/components/Chat/Chat'

import TourRegister from '@/components/Tours/TourRegister'

import Dashboard from '@/components/Admin/Dashboard'

// Static pages
import Terms from '@/components/Static/Terms'

import BaseDashboard from '@/components/BaseDashboard'

import { store } from '@/store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'base',
      component: Base,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'admin',
          component: Dashboard,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/tour/',
      name: 'tour-register',
      component: TourRegister,
      props: true
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset
    },
    {
      path: '/public-profile/:id',
      name: 'public-profile',
      component: PublicProfile,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: Leaderboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      component: BaseDashboard,
      children: [
        {
          path: '',
          name: 'profile',
          component: ProfileBase,
          meta: { requiresAuth: true }
        },
        {
          path: 'edit',
          name: 'profile-edit',
          component: ProfileEdit,
          meta: { requiresAuth: true }
        },
        {
          path: 'password',
          name: 'password-edit',
          component: PasswordEdit,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/gps',
      name: 'gps-tracks',
      component: GPSTracks,
      meta: { requiresAuth: true }
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
      meta: { requiresAuth: true }
    },
    {
      path: '/hikes/add/:id?',
      name: 'hike-add',
      component: HikeAdd,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/hikes/:id',
      name: 'hike',
      component: Hike,
      meta: { requiresAuth: true }
    },
    {
      path: '/hikes',
      name: 'hikes',
      component: Hikes,
      meta: { requiresAuth: true }
    },
    {
      path: '/badges',
      name: 'badges',
      component: Badges,
      meta: { requiresAuth: true }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '*',
      component: Base
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = store.state.auth.user
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next('login')
  else if (requiresAuth && currentUser) next()
  else next()
})

export default router
